<template>
  <div class="col-lg-9 c-content-main">
    <div class="tile">
      <h3 class="tile-title is-line">{{ $t('signInWithOtherDevice') }}</h3>
      <b-tabs class="c-tabs-button" small pills v-model="tab.type">
        <b-tab title="GS Wave"></b-tab>
        <b-tab title="Zoiper"></b-tab>
        <b-tab title="IP phone"></b-tab>
      </b-tabs>
      <div v-if="tab.type===0" class="alert alert-warning">
<!--        <h4>{{$t('signInWithGSWave')}}</h4>-->
        <p>{{ $t('GSWaveHelp') }}</p>
        <div class="text-center">
          <q-r-code :value="gsWaveCode" size="200"></q-r-code>
        </div>
      </div>
      <div v-else-if="tab.type===1" class="alert alert-warning">
<!--        <h4>{{$t('signInWithZoiper')}}</h4>-->
        <p>{{$t('zoiperHelp')}}</p>
        <p>
          <span>Domain: </span>
          <span>{{$store.state.user.client.domain}}</span>
        </p>
        <p>
          <span>{{$t('username')}}: </span>
          <span>{{$store.state.user.ext}}@{{$store.state.user.client.domain}}</span>
        </p>
        <p>
          <span>{{$t('extPassword')}}: {{$store.state.user.extPassword}} </span>
        </p>
      </div>
      <div v-else class="alert alert-warning">
        <p>{{$t('ipPhoneHelp')}}</p>
        <p>
          <span>SIP Server/ Secondary SIP Server/ Outbound proxy: </span>
          <span>{{$store.state.user.ext}}@{{$store.state.user.client.domain}}</span>
        </p>
        <p>
          <span>SIP User ID </span>
          <span>{{$store.state.user.ext}}</span>
        </p>
        <p>
          <span>{{$t('extPassword')}}: {{$store.state.user.extPassword}} </span>
        </p>
        <p>
          <span>STUN server: stun.l.google.com:19302</span>
        </p>
        <p>
          <span>NAT Traversal: STUN</span>
        </p>
        <p><a href="https://callio.vn/huong-dan-nghe-goi-tren-callio-bang-ip-phone/" target="_blank">{{$t('clickHereForMoreInfo')}}</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode.vue';

export default {
  components: {QRCode},
  data: function () {
    return {
      tab: {
        type: 0
      },
      gsWaveCode: "<?xml version='1.0' encoding='utf-8'?><AccountConfig version='1'>" +
          "<Account><RegisterServer>" + this.$store.state.user.client.domain + "</RegisterServer>" +
          "<OutboundServer></OutboundServer>" +
          "<UserID>" + this.$store.state.user.ext + "</UserID>" +
          "<AuthID>" + this.$store.state.user.ext + "</AuthID>" +
          "<AuthPass>" + this.$store.state.user.extPassword + "</AuthPass>" +
          "<AccountName>" + this.$store.state.user.client.domain + "</AccountName>" +
          "<DisplayName></DisplayName>" +
          "<Dialplan></Dialplan>" +
          "<RandomPort>0</RandomPort><SecOutboundServer></SecOutboundServer><Voicemail></Voicemail></Account>" +
          "</AccountConfig>",
    }
  }
}
</script>